import { computed, observable, component } from 'knockout-decorators'

import { RecoveryEmailStatus } from '@tixa/schema'
import { ErrorReporter, Language } from '~/utils'
import { pageState } from '~/store/page'
import { authState } from '../utils/state'

import type { SignInOptions } from '../utils/options'

import source from './lost-password.html?raw'

@component('lost-password-form', source)
export class LostPasswordForm {
  constructor(private options: SignInOptions) {}
  private Locale = Language.getInstance()

  public i18n(key: string): string {
    return this.Locale.translations[key]
  }

  private state = authState

  @observable public email = authState.email
  @observable public isFeedbackVisible = false
  @computed get canRequestRecovery(): boolean {
    return this.state.email.length > 0
  }

  private async requestRecovery() {
    if (this.state.isLoading) return
    this.isFeedbackVisible = false
    this.state.isLoading = true

    try {
      const response = await pageState.api.authentication.requestRecovery({
        email: this.state.email,
      })
      if (response.status === RecoveryEmailStatus.success) {
        this.state.appRecoveryKey = response.appKey
        this.options.recoverAccount()
      } else {
        this.isFeedbackVisible = true
      }
    } catch (error) {
      ErrorReporter.exception(error as Error)
      this.isFeedbackVisible = true
    } finally {
      this.state.isLoading = false
    }
  }

  private gotoLogin() {
    this.options.signIn()
  }
}
